import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../views/Home';
import RegisterUser from '../views/Public/RegisterUser';
import RegisterDoctor from '../views/Public/RegisterDoctor';
import NuestrosProductos from '../views/Public/NuestrosProductos';
import QuienesSomos from '../views/Public/QuienesSomos';
import LoginGral from '../views/Public/LoginGral';
import SolicitudNewPassword from '../views/Public/SolicitudNewPassword';
import RecoverPassword from '../views/Public/RecoverPassword';
import HomeUser from '../views/User/HomeUser';
import ProtectedRoute from '../components/ProtectedRoute';
import SignosVitales from '../views/User/SignosVitales';
import Postura from '../views/User/Postura';
import CitasUser from '../views/User/CitasUser';
import Perfil from '../views/User/PerfilUser';
import HomeDoctor from '../views/Doctor/HomeDoctor';
import Pacientes from '../views/Doctor/Pacientes';
import DetallePaciente from '../views/Doctor/DetallePaciente';
import CitasDoctor from '../views/Doctor/CitasMedico';
import DashboardAdmin from '../views/Admin/HomeAdmin';
import SuscripcionPay  from '../views/User/SuscripcionPay';
import PracticaIot from '../views/Public/iot';


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<RegisterUser />} />
      <Route path="/login" element={<LoginGral />} />
      <Route path="/trabaja-con-nosotros" element={<RegisterDoctor />} />  
      <Route path="/productos" element={<NuestrosProductos />} />
      <Route path="/quienes-somos" element={<QuienesSomos />} />
      <Route path="/solicitud-recuperar" element={<SolicitudNewPassword />} />
      <Route path="/recuperar-contrasena/:token" element={<RecoverPassword />} />
      <Route path="/practicaiot" element={<PracticaIot />} />

      {/* Rutas protegidas */}
      <Route
        path="/SignosVitales"
        element={
          <ProtectedRoute>
            <SignosVitales />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Postura"
        element={
          <ProtectedRoute>
            <Postura />
          </ProtectedRoute>
        }
      />
      <Route
        path="/PerfilUser"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CitasUser"
        element={
          <ProtectedRoute>
            <CitasUser />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user/home"
        element={
          <ProtectedRoute>
            <HomeUser />
          </ProtectedRoute>
        }
      />

      <Route
        path="/doctor/home"
        element={
          <ProtectedRoute>
            <HomeDoctor />
          </ProtectedRoute>
        }
      />

      <Route
        path="/doctor/pacientes"
        element={
          <ProtectedRoute>
            <Pacientes />
          </ProtectedRoute>
        }
      />

      <Route 
        path="/doctor/pacientes/:iduser" 
        element={
          <ProtectedRoute>
            <DetallePaciente />
          </ProtectedRoute>
          } 
      />

      <Route 
        path="/doctor/citas" 
        element={
          <ProtectedRoute>
            <CitasDoctor />
          </ProtectedRoute>
          } 
      />


      <Route 
        path="/admin/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardAdmin />
          </ProtectedRoute>
        } 
      />

      <Route
        path="/suscripcion"
        element={
          <ProtectedRoute>
            <SuscripcionPay />
          </ProtectedRoute>
        }
      />

    </Routes>
  );
};

export default AppRoutes;
